// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

// Valtech Custom Code
import { productNumbers } from "@store/Themes/common/props/product";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    // Valtech Custom Code
    wrapper?: InjectableCss;
    vendorLabelText?: TypographyProps;
    vendorValueText?: TypographyProps;
}

export const partNumberStyles: ProductDetailsPartNumberStyles = {
    labelText: productNumbers.labelText,
    valueText: productNumbers.valueText,
    wrapper: {
        css: css`
            display: block !important;
        `,
    },
    vendorLabelText: {
        color: "text.main",
        transform: "uppercase",
        css: css`
            display: flex;
            width: auto;
            margin-right: ${pxToRem(5)};
            white-space: nowrap;
            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.base};
                font-size: ${theme.design.typography.size.tiny};
            `}
        `,
    },
    vendorValueText: {
        color: "text.dark",
        transform: "uppercase",
        css: css`
            display: flex;
            flex-wrap: wrap;
            width: auto;
            white-space: nowrap;
            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.bold};
                font-size: ${theme.design.typography.size.tiny};
            `}
        `,
    },
};

const styles = partNumberStyles;

const ProductDetailsPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.productNumber) {
        return null;
    }

    // Valtech Custom Code -->
    const vendorSku = product.attributeTypes?.filter(
        attribute => attribute.name === constants.attributeTypes.BCHVendorSku,
    )?.[0];
    const vendorSkuValue = vendorSku?.attributeValues?.[0]?.valueDisplay;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsPartNumber">
                <Typography {...styles.labelText}>{translate("Bunzl #:")}</Typography>
                {product.productNumber}
            </Typography>

            {vendorSkuValue && (
                <Typography {...styles.vendorValueText} as="p" data-test-selector="productDetails_attributes">
                    <Typography {...styles.vendorLabelText}>{translate("BCH Vendor Sku #: ")}</Typography>
                    {vendorSkuValue}
                </Typography>
            )}
        </StyledWrapper>
    );
    // <-- Valtech Custom Code
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPartNumber),
    definition: {
        displayName: "Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
